export const styles = {
  recommendationIconWrapper: {
    display: "inline-flex",
    alignItems: "center",
    flexShrink: 0,
    verticalAlign: "middle",
  },
  recommendationIconInner: {
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
  },
  recommendationIcon: (theme) => ({
    color: theme.palette.warning.dark,
  }),
  recommendationTooltip: (theme) => ({
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.black,
    maxWidth: 320,
  }),
  recommendationArrow: (theme) => ({
    color: theme.palette.warning.main,
  }),
  recommendationPopover: (theme) => ({
    p: 1,
    whiteSpace: "pre-line",
    color: theme.palette.common.black,
  }),
  recommendationTitle: (theme) => ({
    mb: 0.5,
    color: theme.palette.common.black,
  }),
}
